setTimeout(() => {
    const singleFloaties = document.querySelectorAll('.block.is-floated');

    if (singleFloaties) {
        [...singleFloaties].forEach((floatie) => {
            const nextBlock = floatie.nextElementSibling;

            if (nextBlock && nextBlock.classList.contains('clearfix')) {
                floatie.classList.add('overflow-auto');
            }
        });
    }

    const pairedFloaties = document.querySelectorAll('.block.is-floated + .block.is-floated');

    if (pairedFloaties) {
        [...pairedFloaties].forEach((lastFloatie) => {
            const nextBlock = lastFloatie.nextElementSibling;
            const childBlock = lastFloatie.firstElementChild;

            if (nextBlock && nextBlock.classList.contains('block--text')) {
                nextBlock.classList.add('clearfix');
            }

            if (childBlock) {
                childBlock.classList.add('is-padded');
            }
        });
    }
}, 300);
